var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 1.5,
    stroke: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69235 21L14.6924 23.8868L14.6924 18.1132L9.69235 21ZM32.3077 21L32.3077 20.5L14.1924 20.5L14.1924 21L14.1924 21.5L32.3077 21.5L32.3077 21Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevb);
export default __webpack_public_path__ + "static/media/prevb.2be0ba0db0afad72ce5c46e24036cec2.svg";
export { ForwardRef as ReactComponent };